<template>
  <transition appear name="fade">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Logging you in...</span>
    </div>
  </transition>
</template>

<script>
// TODO move these to "store"
const LOCALSTORAGE_STANDARD_UI_LOGO = 'loginStandardUILogo'
const LOCALSTORAGE_STANDARD_UI_COPY = 'loginStandardUICopy'
const LOCALSTORAGE_CUSTOM_UI_ID = 'loginCustomUIID'

export default {
  methods: {
    fetchCompany: function () {
      this.$store.dispatch('company/fetchCompany')
          .then(() => {
            if (this.$store.state.company.logoUrl) {
              localStorage.setItem(LOCALSTORAGE_STANDARD_UI_LOGO, this.$store.state.company.logoUrl)
            } else {
              localStorage.removeItem(LOCALSTORAGE_STANDARD_UI_LOGO)
            }
            if (this.$store.state.company.loginCopyHtml) {
              localStorage.setItem(LOCALSTORAGE_STANDARD_UI_COPY, this.$store.state.company.loginCopyHtml)
            } else {
              localStorage.removeItem(LOCALSTORAGE_STANDARD_UI_COPY)
            }
            if (this.$store.state.company.customLoginId) {
              localStorage.setItem(LOCALSTORAGE_CUSTOM_UI_ID, this.$store.state.company.customLoginId)
            } else {
              localStorage.removeItem(LOCALSTORAGE_CUSTOM_UI_ID)
            }
          })
    },
    showError: function (message) {
      this.$bvModal.msgBoxOk(message, {
        size: 'sm',
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0',
        centered: true
      })
    }
  },
  created () {
    let token = this.$route.query.token
    let is_divvy_admin_flow = this.$route.query.is_divvy_admin_flow === 'true'
    console.log("*******************************")
    console.log(token)
    console.log(is_divvy_admin_flow)
    if (!token) {
      this.$router.push({ name: 'LoginRoot' })
    } else {
      this.$store.dispatch('auth/autoLogIn', {token, is_divvy_admin_flow})
          .then((resp) => {
                this.fetchCompany()
                let clientHasHeadphoneAccessoriesCategory = [500248,500416];
                console.log("HERE")
                if (clientHasHeadphoneAccessoriesCategory.includes(resp.data.clientId)) {
                  console.log("HERE1")
                  this.$router.push({ path: "/shop/category/20267" });
                } else if (resp.data.clientId == 500408) {
                  console.log("HERE2")
                  this.$router.push({ path: "/shop/category/20254" });
                } else if (resp.data.clientId == 500427) {
                  console.log("HERE2")
                  this.$router.push({ path: "/shop/category/18794" });
                } else if (resp.data.clientId == 500411 || resp.data.clientId == 500426) {
                  console.log("HERE3")
                  this.$router.push({ path: "/shop/category/1" });
                } else {
                  this.$router.push({ name: 'Home' })
                }
              },
              (err) => {
                if (err.response.status === 403) {
                  this.showError('Invalid token')
                } else {
                  this.showError('Unknown error')
                }
                this.$router.push({ name: 'LoginRoot' })
              })
    }
  }
}
</script>

<style scoped>

</style>